import { ELocalStorageKey } from '@/enums/ELocalStorageKey';
import { use_effect } from '@/hooks/_base/use_effect';
import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { useTranslation } from 'react-i18next';

export function WatcherLanguageLoader() {
  const { i18n } = useTranslation();

  /*
   * EFFECTS
   */
  use_effect(() => void load_languages());

  /*
   * EVENTS
   */

  /*
   * METHODS
   */
  async function load_languages() {
    await i18n.loadNamespaces(Object.values(ENUM__language_type));

    let language_saved = localStorage.getItem(ELocalStorageKey.LANGUAGE) || i18n.resolvedLanguage;

    language_saved = assert_string_not_empty(language_saved, { context: 'savedLanguage' });

    if (!CONSTANTS__shared.SUPPORTED_LANGUAGES.includes(language_saved)) {
      language_saved = ENUM__language_type.ENGLISH;
    }

    if (language_saved != i18n.language) {
      await i18n.changeLanguage(language_saved);
    }
  }

  /*
   * HTML
   */
  return null;
}
